export enum Area {
  listView = 'listView',
  listViewPreview = 'listViewPreview',
  detailView = 'detailView',
  detailViewPreview = "detailViewPreview",
  detailViewFormList = "detailViewFormList",
  previewDetailViewListView = "previewDetailViewListView",
  detailViewFileAttachments = "detailViewFileAttachments",
  entityDashboardListView = 'entityDashboardListView',
  detailViewFormSubmissionList = "detailViewFormSubmissionList",
  detailViewEditMode = "detailViewEditMode",
  userDashboardDetailView = 'userDashboardDetailView',
}